"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appIdReg = void 0;
exports.checkEmail = checkEmail;
exports.codeReg = void 0;
exports.isArray = isArray;
exports.isExternal = isExternal;
exports.isString = isString;
exports.passwordReg = exports.mobileReg = void 0;
exports.validAlphabets = validAlphabets;
exports.validCode = validCode;
exports.validEmail = validEmail;
exports.validLowerCase = validLowerCase;
exports.validMobile = validMobile;
exports.validPassword = validPassword;
exports.validURL = validURL;
exports.validUpperCase = validUpperCase;
exports.versionReg = void 0;
require("core-js/modules/es6.regexp.to-string");
// 电话格式
var mobileReg = /^1[34578]\d{9}$/;
// 验证码格式
exports.mobileReg = mobileReg;
var codeReg = /^\d{6}$/;
// appId
exports.codeReg = codeReg;
var appIdReg = /^wx[0-9A-Za-z]{16}$/;
// 版本号
exports.appIdReg = appIdReg;
var versionReg = /^\d+(\.\d+){0,2}$/;
// 密码格式
exports.versionReg = versionReg;
var passwordReg = /^[0-9A-Za-z]{6,16}$/;
/**
 * @param {string} path
 * @returns {Boolean}
 */
exports.passwordReg = passwordReg;
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * 验证密码
 * @param {string} password
 * @returns {Boolean}
 */
function validPassword(password) {
  return passwordReg.test(password);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validMobile(str) {
  return mobileReg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validCode(str) {
  return codeReg.test(str);
}
/**
 * @param {string} url
 * @returns {Boolean}
 */
function validURL(url) {
  var reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function validAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
function validEmail(email) {
  var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }
  return Array.isArray(arg);
}

// 邮箱校验
function checkEmail(email) {
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}